class Newsletter extends HTMLElement {
    constructor() {
        super();
        
        const form = this.querySelector('form')
        const listId = form.dataset.klaviyoListId

        form.addEventListener('submit', async (e) => {
            e.preventDefault()

            const formData = new FormData(form)
            const email = formData.get('email')

            this.dataset.status = 'submitting'

            const options = {
                method: 'POST',
                headers: {revision: '2024-02-15', 'content-type': 'application/json'},
                body: JSON.stringify({
                  data: {
                    type: 'subscription',
                    attributes: {
                      profile: {
                        data: {
                          type: 'profile',
                          attributes: {
                            email: email
                          }
                        }
                      }
                    },
                    relationships: {list: {data: {type: 'list', id: listId}}}
                  }
                })
            };
              
            try {
                await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SZUNcm', options)
                    .then(response => console.log(response))
                    .catch(err => console.error(err));

                this.dataset.status = 'submitted'

            } catch(error) {
                console.log(error);
            }
        })
    }
  }
  
  customElements.define('newsletter-component', Newsletter);
  